"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.get_document_elements_thunk = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const main_1 = require("../../../main");
const document_1 = require("../../document");
const get_document_elements_1 = require("../../../../../api/calls/document/get_document_elements");
exports.get_document_elements_thunk = (0, toolkit_1.createAsyncThunk)("documents/thunks/get_document_elements_thunk", (arg, { dispatch, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const { data, loader = true } = arg;
    dispatch((0, document_1.setIsLoading)(true));
    // Get document status from Redux state to determine correct endpoint
    const state = getState();
    const documentStatus = (_a = state.documentState.selectedDocument) === null || _a === void 0 ? void 0 : _a.status;
    // Pass document status to the API call to use the correct endpoint
    const response = yield (0, get_document_elements_1.get_document_elements)(Object.assign(Object.assign({}, data), { documentStatus: documentStatus }), loader);
    dispatch((0, document_1.setIsLoading)(false));
    if (response.success) {
        dispatch((0, document_1.setSelectedDocumentElements)((_b = response.content) === null || _b === void 0 ? void 0 : _b.documents_elements));
    }
    else {
        dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.message] }));
    }
}));
